import React, { useCallback, useEffect, useRef, useState } from "react";
import { View, StyleSheet, Alert } from "react-native";
import { useRoute, useNavigation } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import GameTable from "../Components/Game/GameTable";
import InvitePlayerToTableModal from "../Components/Modals/InvitePlayerToTableModal";
import BecomeVipModal from "../Components/Modals/BecomeVipModal";
import { analyticsEvents } from "../../services/firebase/analytics-events.service";
import { getRoomByName } from "../../api/gameApi";
type GameScreenProps = NativeStackScreenProps<RootStackParamList, "Game">;

const GameScreen: React.FC = () => {
  const route = useRoute<GameScreenProps["route"]>();
  const navigation = useNavigation<GameScreenProps["navigation"]>();

  const {
    tableId,
    legacyRoomId,
    roomSlug,
    isTutorial,
    tableName,
    tableStringId,
    isTournamentRoom,
  } = route.params || {};
  const [showInvitesModal, setShowInvitesModal] = useState(false);
  const [showBecomeVipModal, setShowBecomeVipModal] = useState(false);
  const stableTimestamp = useRef(
    (route.params && route.params.timestamp) || Date.now(),
  ).current;

  useEffect(() => {
    // 🔥 Track table opened
    analyticsEvents.trackOpenTable(roomSlug, tableId);
  }, [tableId, roomSlug]);

  const handleGameEvent = useCallback(
    (event: string, data?: any) => {
      console.log("Game event received:", event, data);

      switch (event) {
        case "goToLobby": {
          // const targetSlug = data?.roomSlug || roomSlug;
          // const targetId = data?.roomId || targetSlug;

          // // Replace Game with Room so WebView unmounts and cleans up
          // navigation.replace("Room", {
          //   roomSlug: targetSlug,
          //   roomId: targetId,
          // });
          navigation.replace("Lobby");
          break;
        }

        case "becomeVIP":
          setShowBecomeVipModal(true);
          break;

        case "notEnoughChips":
          // Handle not enough chips modal
          Alert.alert(
            "Not Enough Chips",
            "You need more chips to continue playing.",
          );
          break;

        case "buyChips":
          // Handle buy chips modal
          Alert.alert("Buy Chips", "Redirecting to shop...");
          break;

        case "invite":
          // Handle invite modal
          setShowInvitesModal(true);
          break;

        case "setSound":
          // Handle sound settings
          console.log("Sound setting changed:", data);
          break;

        case "openNotifications":
          // Handle notifications
          navigation.navigate("Messages");
          break;

        case "showBlackscreenAlert":
          // Handle blackscreen warning
          Alert.alert(
            "Performance Warning",
            "Your device may have performance issues.",
          );
          break;

        case "hideBlackscreenAlert":
          // Hide blackscreen warning
          console.log("Blackscreen alert hidden");
          break;

        case "tableDoesNotExist":
          // Handle table not found
          Alert.alert("Table Not Found", "This table no longer exists.", [
            { text: "OK", onPress: () => navigation.goBack() },
          ]);
          break;

        default:
          console.log("Unhandled game event:", event, data);
      }
    },
    [navigation],
  );

  return (
    <View style={styles.container}>
      <GameTable
        key={`${tableId}-${stableTimestamp}`}
        tableId={tableId}
        legacyRoomId={legacyRoomId}
        roomSlug={roomSlug}
        isTutorial={isTutorial}
        onGameEvent={handleGameEvent}
        isTournamentRoom={isTournamentRoom}
      />
      {showInvitesModal && (
        <InvitePlayerToTableModal
          onClose={() => setShowInvitesModal(false)}
          tableId={tableId}
          tableName={tableName}
        />
      )}
      {showBecomeVipModal && (
        <BecomeVipModal onClose={() => setShowBecomeVipModal(false)} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#000",
  },
});

export default GameScreen;
